<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="5" height="8" viewBox="0 0 5 8" fill="none">
    <path
      d="M1.26607 7.98207C1.46794 6.81388 1.66982 5.64531 1.87446 4.45957H0C1.1462 2.94699 2.26283 1.4733 3.37947 0C3.39524 0.00228833 3.4114 0.00457666 3.42717 0.00686499C3.32781 1.17506 3.22806 2.34363 3.12712 3.5328H5C3.74655 5.04653 2.52385 6.52326 1.30076 8C1.28933 7.9939 1.2775 7.98818 1.26607 7.98207Z"
      fill="#5179FF" />
  </svg>

</template>
